import API from '@/api/Residential'
import { Debounce } from '@/utils'
import { i18n } from '@/i18n'

const check = Debounce((cadastre, passes, msg, draft) => {
  API.validateCadastre({ cadastre }, { draft })
    .then(() => passes())
    .catch(() => passes(false, msg))
}, 300)

export default Validator => {
  Validator.registerAsync('cadastre', function (cadastre, attribute, req, passes) {
    let [initialValue, draft] = attribute.split(',')
    if (initialValue === cadastre) return passes()

    const isValid = cadastre.split('/').every(c => /^\d+$|^[-]*$/.test(c))
    if (!isValid) return passes(false, i18n.t('invalid', { x: i18n.t('cadastre') }))

    const isCompleted = /[\d]{4}\/[\d]{3}\/[\d]{4}\/[\d]{2}\/[\d]{2}/.test(cadastre)
    if (isCompleted) return check(cadastre, passes, i18n.t('isTaken', { x: i18n.t('cadastre') }), draft)

    return passes()
  })
}
